import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";

export function column_Density(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "importDensity", "density", {
		isNumber: true,
		options: context.gridSizes,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}
